export default "__VITE_ASSET__CflTZpG2__"